<template>
    <div class="image">
        <slot>
            <svg width="100%"  viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Group">
                    <rect id="Rectangle" fill="#000000" x="0" y="0" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-4" fill="#FFFFFF" x="0" y="30" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-8" fill="#000000" x="0" y="60" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-12" fill="#FFFFFF" x="0" y="90" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy" fill="#FFFFFF" x="30" y="0" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-5" fill="#000000" x="30" y="30" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-9" fill="#FFFFFF" x="30" y="60" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-13" fill="#000000" x="30" y="90" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-2" fill="#000000" x="60" y="0" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-6" fill="#FFFFFF" x="60" y="30" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-10" fill="#000000" x="60" y="60" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-14" fill="#FFFFFF" x="60" y="90" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-3" fill="#FFFFFF" x="90" y="0" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-7" fill="#000000" x="90" y="30" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-11" fill="#FFFFFF" x="90" y="60" width="30" height="30"></rect>
                    <rect id="Rectangle-Copy-15" fill="#000000" x="90" y="90" width="30" height="30"></rect>
                </g>
            </svg>
        </slot>

        <DotsVertical class="dots-vertical" />
    </div>
</template>

<script>
import DotsVertical from "./DotsVertical.vue";

export default {
	name: "ImagePlaceholder",
	components: {DotsVertical}
};
</script>

<style scoped>
.dots-vertical {
    position: absolute;
    top: 20px;
    right: 50px;
}

@media (min-width: 1024px) {
    .dots-vertical {
        position: absolute;
        top: -30px;
        left: -50px;
        right: inherit;
    }
}

</style>
